/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */
import { ICellTextProps } from "ka-table/props";
import React from "react";

/**
 * Custom cell component.
 */
const DataCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, ...props
  }) => {
    const value = props.rowData[`${column.key}`];
    const displayValue = value === null || value === undefined || value === "" ? "-" : value;

    return (
      <span className="whitespace-nowrap text-gray-500 w-full text-ellipsis overflow-hidden block text-sm">
        {displayValue}
      </span>
    );
  },
);
export default DataCell;
